document.addEventListener('DOMContentLoaded', function() {
  const faqPageTitle = document.querySelector('.faq-page-title');
  const faqTileButtonDiv = document.querySelector('div[id*="faq_tile_button"].shopify-section');
  const faqPageHeader = document.querySelector('.faq_header');
// start gathering section-faq-tile class under section-faq-tile-wrapper
  const allFaqTiles = document.querySelectorAll('.section-faq-tile');
  if (allFaqTiles.length === 0) return;
  let wrapper = document.querySelector('.section-faq-tile-wrapper');

  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.classList.add('section-faq-tile-wrapper', 'container');

    const firstFaqTile = allFaqTiles[0];
    const parentElement = firstFaqTile.parentNode;

    parentElement.insertBefore(wrapper, firstFaqTile);
  }

  allFaqTiles.forEach(tile => {
    wrapper.appendChild(tile);
  });
// end gathering section-faq-tile class under section-faq-tile-wrapper

  if (faqTileButtonDiv) {
    faqTileButtonDiv.style.display = 'none';
  }
  if (faqPageTitle && faqPageTitle.classList.contains('hidden')) {
    faqPageTitle.classList.remove('hidden')
    const faqPageTitleClone = faqPageTitle;
    faqPageTitle.remove();

    const faqTilesWithId = document.querySelector('div[id*="__faq_tile_"]');
    faqTilesWithId.before(faqPageTitleClone.cloneNode(true));
  }
  const faqTileSection = document.querySelector('.faq-tile');
  const faqTiles = document.querySelectorAll('.faq-tile');
  const faqTilesContainer = document.querySelectorAll('.page-container .faq-tile');
  if (window.innerWidth > 989) {
    if (faqTilesContainer.length >= 3) {
      faqTilesContainer[2].style.marginInlineEnd = '0';
      faqTilesContainer.forEach((tile, index) => {
        if (index != 2) {
          tile.style.marginInlineEnd = '1.8rem';
        }
        tile.style.width = '31.6%';
      });
    }
    if (faqTilesContainer.length === 1) {
      faqTilesContainer[0].style.width = '100%';
      faqTilesContainer[0].style.marginInlineEnd = '0';
    }

    if (faqTilesContainer.length === 2) {
      faqTilesContainer.forEach((tile, index) => {
        tile.style.width = '48.1%';
        if (index === 0) {
          tile.style.marginInlineEnd = '2.9rem';
        }
      });
    }
    if (faqTilesContainer.length >= 4) {
      faqTilesContainer.forEach((tile, index) => {
        if (index >= 3) {
          tile.style.width = '23%';
          tile.style.maxWidth = '26rem';
          tile.style.marginInlineEnd = '1.9rem';
        }
        if ((index + 1) % 4 === 3) {
          tile.style.marginInlineEnd = '0';
        }
      });
    }
  }

  if (window.innerWidth >= 1024 && window.innerWidth <= 1200) {
    if (faqTilesContainer.length === 2) {
      faqTilesContainer.forEach((tile, index) => {
        if (index === 0) {
          tile.style.marginInlineEnd = '2.3rem';
        }
        tile.style.width = '48.1%';
      });
    }
    if (faqTilesContainer.length >= 3) {
      faqTilesContainer.forEach((tile, index) => {
        tile.style.marginInlineEnd = '1.4rem';
      });
      faqTilesContainer[2].style.marginInlineEnd = '0';
    }
    if (faqTilesContainer.length >= 4) {
      faqTilesContainer.forEach((tile, index) => {
        if (index >= 3) {
          tile.style.width = '23.4%';
        } else {
          tile.style.width = '31.9%';
        }
        if ((index + 1) % 4 === 3) {
          tile.style.marginInlineEnd = '0';
        }
      });
    }
  }

  const faqContentElements = document.querySelectorAll('.faq-tile__content');
  const faqListElements = document.querySelectorAll('.faq-tile__list');
  const backButton = document.querySelector('.faq-tile__list--back-button');
  const sidebarElement = document.querySelector('.faq-tile__list--sidebar');
  const scrollToFirstTile = () => {
    if (window.innerWidth < 990) {
        const faqTileWrapper = document.querySelector('.faq-tile__list');
        if (faqTileWrapper) {
          const headerHeight = document.querySelector('header')?.offsetHeight || 0;
          const offset = faqTileWrapper.getBoundingClientRect().top + window.scrollY - headerHeight - 32;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
    }
  };
  backButton.addEventListener('click', function() {
    if (faqTileButtonDiv) {
      faqTileButtonDiv.style.display = 'block';
    }
    if (faqPageHeader) {
      faqPageHeader.style.display = 'block';
    }
    if (faqTilesContainer) {
      faqTilesContainer.forEach(tile => {
        tile.style.width = '';
      });
    }
    faqListElements.forEach(list => {
      list.style.display = 'none';
    });
    if (faqPageTitle && faqPageTitle.classList.contains('hidden')) {
      faqPageTitle.classList.remove('hidden')
    }
    if (faqTileSection) {
      faqTileSection.style.marginBlockStart = '2.4rem'
    }
    const faqTileDiv = document.querySelector('div[id*="_faq_tile_"]');

    if (faqTileDiv) {
      faqTileDiv.style.display = 'inline';
    }
    if (window.innerWidth >= 990) {
      if (faqTilesContainer.length >= 3) {
        faqTilesContainer.forEach(tile => {
          tile.style.marginInlineEnd = '1.8rem';
        });
      }
      if (faqTilesContainer.length === 1) {
        faqTilesContainer[0].style.width = '79.8%';
        faqTilesContainer[0].style.marginInlineEnd = '0';
      }

      if (faqTilesContainer.length === 2) {
        faqTilesContainer.forEach((tile, index) => {
          tile.style.width = '48.1%';
          if (index === 0) {
            tile.style.marginInlineEnd = '2.9rem';
          }
        });
      }
      if (faqTilesContainer.length >= 3) {
        faqTilesContainer[2].style.marginInlineEnd = '0';
        faqTilesContainer.forEach((tile, index) => {
          tile.style.width = '31.6%';
        });
      }
      if (faqTilesContainer.length >= 4) {
        faqTilesContainer.forEach((tile, index) => {
          if (index >= 3) {
            tile.style.width = '23%';
            tile.style.maxWidth = '26rem';
            tile.style.marginInlineEnd = '1.9rem';
          }
          if ((index + 1) % 4 === 3) {
            tile.style.marginInlineEnd = '0';
          }
        });
      }
    }
    if (window.innerWidth < 989) {
      if (faqTilesContainer) {
        faqTilesContainer.forEach((tile) => {
          tile.style.width = '100%';
        });
      }
    }
    if (window.innerWidth >= 1024 && window.innerWidth <= 1200) {
      if (faqTilesContainer.length === 2) {
        faqTilesContainer.forEach((tile, index) => {
          if (index === 0) {
            tile.style.marginInlineEnd = '2.3rem';
          }
          tile.style.maxWidth = '50rem';
        });
      }
      if (faqTilesContainer.length >= 3) {
        faqTilesContainer.forEach(tile => {
          tile.style.marginInlineEnd = '1.4rem';
        });
        faqTilesContainer[2].style.marginInlineEnd = '0';
      }
      if (faqTilesContainer.length >= 4) {
        faqTilesContainer.forEach((tile, index) => {
          if (index >= 3) {
            tile.style.width = '23.4%';
          } else {
            tile.style.width = '31.9%';
          }
          if ((index + 1) % 4 === 3) {
            tile.style.marginInlineEnd = '0';
          }
        });
      }
    }
    const allFaqSections = document.querySelectorAll('.faq-tile');
    allFaqSections.forEach((faqSection) => {
      const shopifySection = faqSection.closest('[id^="shopify-section-template"]');
      shopifySection.style.width = '';
    })
    const backButtons = document.querySelectorAll('.faq-tile__list--back-button');
    backButtons.forEach(button => {
      button.style.display = 'none';
    });
    faqContentElements.forEach(list => {
      list.style.display = 'flex';
    });

    faqTiles.forEach((div) => {
      div.classList.add('faq-tile-wrapper');
      div.classList.remove('hidden')
    });
  });

  faqContentElements.forEach(content => {
    const media = content.querySelector('.faq-tile__content--media');
    const text = content.querySelector('.faq-tile__content--title');
    const allFaqSections = document.querySelectorAll('.faq-tile');

    let uniqueFaqTextsArray = [];
    let subtitleTextsArray = [];
    let subtitleContentArray = [];
    let allTitles = [];

    const hideAllShowList = event => {
      const faqTileTitles = document.querySelectorAll('.faq-tile__content--title');

      faqTileTitles.forEach(title => {
        title.addEventListener('click', function(event) {
          event.stopPropagation(); // prevent event bubbling
          scrollToFirstTile();
        });
      });

      if (faqPageHeader) {
        faqPageHeader.style.display = 'none';
      }
      if (faqTileButtonDiv) {
        faqTileButtonDiv.style.display = 'block';
      }

      if (faqPageTitle) {
        faqPageTitle.classList.add('hidden');
      }
      if (faqTilesContainer) {
        faqTilesContainer.forEach((tile) => {
          if (window.innerWidth <= 990) {
            tile.style.width = '100%';
          } else {
            tile.style.width = 'auto';
          }
        });
      }
      if (faqTileSection) {
        faqTileSection.style.marginBlockStart = '-2.4rem';
      }
      allFaqSections.forEach((faqSection, index) => {
        if (index != 0) {
          faqSection.classList.add('hidden');
        }
        const faqTextItems = faqSection.querySelectorAll(
          '.faq-tile__content--title'
        );
        backButton.style.display = 'flex';
        faqTextItems.forEach(item => {
          const text = item.textContent.trim();
          if (!uniqueFaqTextsArray.includes(text)) {
            uniqueFaqTextsArray.push(text);
          }
        });

        const backButtons = document.querySelectorAll('.faq-tile__list--back-button');
        backButtons.forEach((button, index) => {
          if (index > 0) {
            button.style.display = 'none';
          }
        });

        const subtitleElement = faqSection.querySelector('.faq-tile__content--subtitle');
        if (subtitleElement) {
          const subtitleItems =
            subtitleElement.querySelectorAll('div');
          subtitleItems.forEach(div => {
            const subtitleText = div.textContent.trim();
            if (
              subtitleText &&
              !subtitleTextsArray.includes(subtitleText)
            ) {
              subtitleTextsArray.push(subtitleText);
            }
          });
        }

        const shopifySection = faqSection.closest('[id^="shopify-section-template"]');
        if (shopifySection) {
          shopifySection.style.width = '100%';
        }

        const subtitleContent = faqSection.querySelector('.faq-tile__content--subtitle-content');
        if (subtitleContent) {
          const subtitleContentItems =
            subtitleContent.querySelectorAll('div');
          subtitleContentItems.forEach(div => {
            const subtitleContent = div.innerHTML.trim();
            if (
              subtitleContent &&
              !subtitleContentArray.includes(subtitleContent)
            ) {
              subtitleContentArray.push(subtitleContent);
            }
          });
        }
      });

      const result = subtitleContentArray.reduce(
        (obj, htmlContent, index) => {
          obj[index] = htmlContent.split('\n');
          return obj;
        },
        {}
      );

      allTitles = uniqueFaqTextsArray.map((faq, index) => {
        return {
          title: faq,
          subtitle: subtitleTextsArray[index].split('\n'),
          description: result[index]
        };
      });

      const contentElement = document.querySelector('.faq-tile__list--content');

      if (sidebarElement && contentElement) {
        sidebarElement.innerHTML = '';
        contentElement.innerHTML = '';

        function createChevronIcon() {
          const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          svg.setAttribute("width", "20");
          svg.setAttribute("height", "20");
          svg.setAttribute("viewBox", "0 0 24 24");
          svg.setAttribute("fill", "none");
          svg.innerHTML = `<path d="M6 9l6 6 6-6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>`;
          svg.style.transition = "transform 0.3s ease";
          svg.classList.add('large-up-hide');
          return svg;
        }

        const menuTitle = document.createElement('div');
        menuTitle.classList.add('faq-menu-title', 'large-up-hide');
        menuTitle.textContent = 'Menu';
        const menuIcon = createChevronIcon();
        menuTitle.appendChild(menuIcon);
        sidebarElement.appendChild(menuTitle);

        let initialDisplayState = {
          titles: new Map(),
          subtitles: new Map(),
          buttons: new Map(),
          isHidden: false
        };

        menuTitle.addEventListener('click', function () {
          const chevronIcon = menuTitle.querySelector('svg');

          chevronIcon.classList.toggle('rotate-chevron');
          const sidebar = document.querySelector('.faq-tile__list--sidebar');
          if (sidebar) {
            const allTitles = sidebar.querySelectorAll('.faq-tile__list--title');
            const allSubtitles = sidebar.querySelectorAll('.faq-tile__list--subtitle');
            const allButtons = sidebar.querySelectorAll('.faq__button');

            if (!initialDisplayState.titles.size) {
              allTitles.forEach(title =>
                initialDisplayState.titles.set(
                  title,
                  title.style.display || 'flex'
                )
              );
              allSubtitles.forEach(subtitle =>
                initialDisplayState.subtitles.set(
                  subtitle,
                  subtitle.style.display || 'block'
                )
              );
              allButtons.forEach(button =>
                initialDisplayState.buttons.set(
                  button,
                  button.style.display || 'block'
                )
              );
            }

            if (!initialDisplayState.isHidden) {
              allTitles.forEach(title => (title.style.display = 'none'));
              allSubtitles.forEach(
                subtitle => (subtitle.style.display = 'none')
              );
              allButtons.forEach(button => (button.style.display = 'none'));
            } else {
              allTitles.forEach(
                title =>
                  (title.style.display =
                    initialDisplayState.titles.get(title))
              );
              allSubtitles.forEach(
                subtitle =>
                  (subtitle.style.display =
                    initialDisplayState.subtitles.get(subtitle))
              );
              allButtons.forEach(
                button =>
                  (button.style.display =
                    initialDisplayState.buttons.get(button))
              );
            }
            initialDisplayState.isHidden = !initialDisplayState.isHidden;
          }
        });

        allTitles.forEach((item, titleIndex) => {
          const titleElement = document.createElement('p');
          titleElement.textContent = item.title;
          titleElement.classList.add('faq-tile__list--title');
          const chevronIcon = createChevronIcon();
          titleElement.appendChild(chevronIcon);
          sidebarElement.appendChild(titleElement);

          titleElement.addEventListener('click', function() {
            chevronIcon.classList.toggle('rotate-chevron');
            let nextElement = this.nextElementSibling;
            if (this.classList.contains('active')) {
              this.classList.remove('active');
              const chevronIconSvg = this.querySelector('svg');
              if (chevronIconSvg && chevronIconSvg.classList.contains('rotate-chevron')) {
                chevronIconSvg.classList.remove('rotate-chevron');
              }
            }

            while (nextElement && !nextElement.classList.contains('faq-tile__list--title')) {
              if (nextElement.classList.contains('faq-tile__list--subtitle')) {
                if (nextElement.style.display === 'none' || nextElement.style.display === '') {
                  nextElement.style.display = 'block';
                } else {
                  nextElement.style.display = 'none';
                }
              }
              nextElement = nextElement.nextElementSibling;
            }
          });
          item.subtitle.forEach((sub, subIndex) => {
            const subtitleElement = document.createElement('p');
            subtitleElement.textContent = sub;
            subtitleElement.style.margin = '0 0 12px 32px';
            subtitleElement.style.display = 'block';
            subtitleElement.classList.add('faq-tile__list--subtitle');
            subtitleElement.addEventListener('click', event => {
              const faqTileWrappers = document.querySelectorAll('.faq-tile-wrapper');
              const faqTileDiv = document.querySelector('div[id*="_faq_tile_"]');

              if (faqTileDiv) {
                faqTileDiv.style.display = 'flex';
              }
              faqTileWrappers.forEach((div) => {
                div.classList.remove('faq-tile-wrapper');
              });

              const allSubtitles = document.querySelectorAll('.faq-tile__list--subtitle');
              allSubtitles.forEach(el => {
                el.style.opacity = '0.5';
              });

              const allTitles = document.querySelectorAll('.faq-tile__list--title');
              allTitles.forEach(title => {
                title.style.opacity = '0.5';

              });

              event.target.style.opacity = '1';
              let currentElement = event.target;
              while (currentElement.previousElementSibling) {
                currentElement =
                  currentElement.previousElementSibling;
                if (currentElement.classList.contains('faq-tile__list--title')) {
                  currentElement.style.opacity = '1';
                  currentElement.classList.add('active')
                  break;
                }
              }
              event.target.style.opacity = '1';
              const allBackButtons = document.querySelectorAll('.faq-tile__list--back-button');
              allBackButtons.forEach((button, index) => {
                if (index > 0) {
                  button.style.display = 'none';
                }
              });

              faqTiles.forEach((tile, index) => {
                if (index !== faqTiles.length - 1) {
                  tile.style.marginInlineEnd = '';
                }
              });
              contentElement.innerHTML = '';
              const subElement = document.createElement('h3');
              subElement.textContent = sub;
              contentElement.appendChild(subElement);
              const descElement = document.createElement('div');
              descElement.innerHTML = item.description[subIndex];
              contentElement.appendChild(descElement);
            });

            sidebarElement.appendChild(subtitleElement);
            if (faqTileButtonDiv) {
              sidebarElement.appendChild(faqTileButtonDiv);
            }
          });
        });
      }

      const clickedTitle = event?.target.textContent.trim();
      const sidebarTitles = document.querySelectorAll('.faq-tile__list--title');
      if (clickedTitle) {
      sidebarTitles.forEach(title => {
        if (title.textContent.trim() === clickedTitle) {
          const firstSubtitle = title.nextElementSibling;
          if (firstSubtitle && firstSubtitle.classList.contains('faq-tile__list--subtitle')) {
            firstSubtitle.click();
          }
        }
      });
      }

      faqContentElements.forEach(c => {
        c.style.display = 'none';
      });

      faqListElements.forEach(list => {
        list.style.display = 'flex';
      });

      sidebarTitles.forEach(title => {
        if (window.getComputedStyle(title).opacity == 0.5) {
          const parent = title.parentElement;
          let nextElement = title.nextElementSibling;
          while (nextElement) {
            if (
              nextElement.classList.contains(
                'faq-tile__list--subtitle'
              )
            ) {
              nextElement.style.display = 'none';
            } else if (
              nextElement.classList.contains('faq-tile__list--title')
            ) {
              break;
            }
            nextElement = nextElement.nextElementSibling;
          }
        }
      });
    };

  const faqSearchInput = document.getElementById('page-banner-faq-search');
  const resultsContainer = document.querySelector('.faq-search-results');

  faqSearchInput?.addEventListener('input', function (e) {
    const searchQuery = e.target.value.toLowerCase();
    resultsContainer.innerHTML = '';

    if (searchQuery) {
      allFaqSections.forEach(faqSection => {
        const faqTextItems = faqSection.querySelectorAll('.faq-tile__content--title');
        faqTextItems.forEach(item => {
          const text = item.textContent.trim();
          if (!uniqueFaqTextsArray.includes(text)) {
            uniqueFaqTextsArray.push(text);
          }
        });

        const subtitleElement = faqSection.querySelector('.faq-tile__content--subtitle');
        if (subtitleElement) {
          const subtitleItems = subtitleElement.querySelectorAll('div');
          subtitleItems.forEach(div => {
            const subtitleText = div.textContent.trim();
            if (subtitleText && !subtitleTextsArray.includes(subtitleText)) {
              subtitleTextsArray.push(subtitleText);
            }
          });
        }

        const subtitleContent = faqSection.querySelector('.faq-tile__content--subtitle-content');
        if (subtitleContent) {
          const subtitleContentItems = subtitleContent.querySelectorAll('div');
          subtitleContentItems.forEach(div => {
            const subtitleContent = div.textContent.trim();
            if (subtitleContent && !subtitleContentArray.includes(subtitleContent)) {
              subtitleContentArray.push(subtitleContent);
            }
          });
        }
      });

      const result = subtitleContentArray.reduce(
        (obj, text, index) => {
          obj[index] = text.split('\n');
          return obj;
        },
        {}
      );

      allTitles = uniqueFaqTextsArray.map((faq, index) => {
        return {
          title: faq,
          subtitle: subtitleTextsArray[index].split('\n'),
          description: result[index]
        };
      });
      const filteredFaqs = allTitles.filter(item =>
        item.title.toLowerCase().includes(searchQuery)
      );

      const submitButton = document.querySelector('.page-banner__faq-search--button');
      const submitButtons = document.querySelectorAll('.page-banner__faq-search--button');
      if (filteredFaqs && filteredFaqs.length > 0) {
        submitButtons.forEach(button => {
          button.style.backgroundColor = '#111111';
        });
        resultsContainer.style.display = 'block';
        if (resultsContainer.classList.contains('faq-search-message')) {
          resultsContainer.classList.remove('faq-search-message');
        }

        const fragment = document.createDocumentFragment(); // Define fragment here

        filteredFaqs.forEach(item => {
          item.subtitle.forEach(sub => {
            const subtitleElement = document.createElement('p');
            subtitleElement.textContent = sub;
            subtitleElement.classList.add('faq-search-subtitle');
            subtitleElement.style.paddingBlock = '16px';
            fragment.appendChild(subtitleElement);
            resultsContainer.appendChild(subtitleElement);

            submitButton.addEventListener('click', () => {
              const firstSubtitleElement = document.querySelector('.faq-search-subtitle');
              if (firstSubtitleElement) {
                firstSubtitleElement.click();
              }
            });

            subtitleElement.addEventListener('click', function() {
              hideAllShowList();
              const clickedSubtitle = this.textContent.trim();
              const subtitleElements = document.querySelectorAll('.faq-tile__list--subtitle');
              subtitleElements.forEach(subtitleElement => {
                if (subtitleElement.textContent.trim() === clickedSubtitle) {
                  subtitleElement.click();
                }
              });

              document.querySelectorAll('.faq-tile__content').forEach(content => {
                content.style.display = 'none';
              });

              const faqTileList = document.querySelector('.faq-tile__list');
              if (faqTileList) {
                faqTileList.style.display = 'flex';
              }

              resultsContainer.style.display = 'none';
              resultsContainer.innerHTML = '';
            });
          });
        });
      } else {
        submitButton.style.backgroundColor = '#9E9A99';
        resultsContainer.style.display = 'flex';
        resultsContainer.classList.add('faq-search-message');
        resultsContainer.innerHTML = `<p>No results found for "${searchQuery}"</p>`;
      }
    } else {
      resultsContainer.style.display = 'none';
    }
  });

  faqSearchInput?.addEventListener('focus', function() {
    if (this.value) {
      this.dispatchEvent(new Event('input'));
    }
  });

  document.addEventListener('click', function (event) {
    const isClickInside = faqSearchInput && faqSearchInput.contains(event.target) || resultsContainer && resultsContainer.contains(event.target);

    if (!isClickInside && resultsContainer) {
      resultsContainer.style.display = 'none';
    } else if (resultsContainer) {
      resultsContainer.style.display = 'block';
    };
  });

  document.querySelectorAll('.faq-tile__content--media').forEach(mediaElement => {
    mediaElement.addEventListener('click', function () {
      const faqTileWrappers = document.querySelectorAll('.faq-tile-wrapper');

      faqTileWrappers.forEach((div) => {
        div.classList.remove('faq-tile-wrapper');
      });

      faqTiles.forEach((tile, index) => {
        if (index !== faqTiles.length - 1) {
          tile.style.marginInlineEnd = '';
        }
      });

      const faqTileDiv = document.querySelector('div[id*="_faq_tile_"]');

      if (faqTileDiv) {
        faqTileDiv.style.display = 'flex';
      }

      if (faqPageTitle) {
        faqPageTitle.classList.add('hidden')
      }
      const faqContent = mediaElement.closest('.faq-tile__content');
      if (faqContent) {
        const titleElement = faqContent.querySelector('.faq-tile__content--title');
        titleElement.click()
      }
    });
  });

    text.addEventListener('click', hideAllShowList);
  });
});
